import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { AfterViewInit, Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { BehaviorSubject } from 'rxjs';
import { Perfil, Tela } from 'src/app/models/perfil';
import { Relatorio } from 'src/app/models/relatorios';
import { TodoItemFlatNode } from 'src/app/models/to-do-item-flat-node';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PerfilService } from 'src/app/services/perfil.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';


@Component({
  selector: 'app-cadastrar-perfil-acesso',
  templateUrl: './cadastrar-perfil-acesso.component.html',
  styleUrls: ['./cadastrar-perfil-acesso.component.scss']
})
export class CadastrarPerfilAcessoComponent implements OnInit, OnDestroy, AfterViewInit {
  // variáveis
  idPerfil = '';
  perfil = new Perfil();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;

  // treeview
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMapTela = new Map<TodoItemFlatNode, Tela>();
  flatNodeMapRelatorios = new Map<TodoItemFlatNode, Relatorio>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMapTelas = new Map<Tela, TodoItemFlatNode>();
  nestedNodeMapRelatorios = new Map<Relatorio, TodoItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: TodoItemFlatNode | null = null;
  selectedParentRelatorios: TodoItemFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl: FlatTreeControl<TodoItemFlatNode>;
  treeControlRelatorio: FlatTreeControl<TodoItemFlatNode>;

  treeFlattenerTelas: MatTreeFlattener<Tela, TodoItemFlatNode>;
  treeFlattenerRelatorios: MatTreeFlattener<Relatorio, TodoItemFlatNode>;

  dataSourceTelas: MatTreeFlatDataSource<Tela, TodoItemFlatNode>;
  dataSourceRelatorios: MatTreeFlatDataSource<Relatorio, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  checklistSelectionRelatorios = new SelectionModel<TodoItemFlatNode>(true /* multiple */);

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private perfilService: PerfilService,
    private router: Router,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    private relatorioService: RelatorioService
  ) {
    this.treeFlattenerTelas = new MatTreeFlattener(this.transformerTela, this.getLevel, this.isExpandable, this.getChildren);
    this.treeFlattenerRelatorios = new MatTreeFlattener(this.transformerRelatorio, this.getLevel, this.isExpandable, this.getChildrenRelatorios);

    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.treeControlRelatorio = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);

    this.dataSourceTelas = new MatTreeFlatDataSource(this.treeControl, this.treeFlattenerTelas);
    this.dataSourceRelatorios = new MatTreeFlatDataSource(this.treeControlRelatorio, this.treeFlattenerRelatorios);

    this.dataSourceTelas.data = [];
    this.dataSourceRelatorios.data = [];
  }

  ngOnInit() {
    // se for edição, busca o perfil do id passado
    if (this.route.snapshot.paramMap.get('id')) {
      this.idPerfil = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarPerfil();
    } else {
      this.perfil = new Perfil();
      this.perfil.telas = [];
      this.atualizaDadosPerfil();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarPerfil() {
    this.carregandoService.mostra('buscaPerfil');

    this.perfilService.consultarPorIdPerfil(this.idPerfil).subscribe(tipo => {
      this.perfil = tipo;
      console.log(this.perfil);
      this.atualizaDadosPerfil();
    }, (erro) => {
      this.carregandoService.esconde('buscaPerfil');
      this.notificacaoService.erro(erro);
    });
  }

  buscarTelas() {
    this.carregandoService.mostra('buscarTelas');

    this.perfilService.consultarTelas().subscribe(telas => {
      this.dataSourceTelas.data = telas;

      this.treeControl.dataNodes.forEach(p => {
        if (p.tipo === 1 && this.perfil.telas.some(t => t === p.id)) {
          this.checklistSelection.select(p);
        }
      });

      this.carregandoService.esconde('buscarTelas');
    }, (erro) => {
      this.carregandoService.esconde('buscarTelas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarRelatorios() {
    this.carregandoService.mostra('buscarRelatorios');
    this.perfilService.consultarRelatorios().subscribe(rel => {
      this.dataSourceRelatorios.data = rel;

      this.treeControlRelatorio.dataNodes.forEach(p => {
        if (this.perfil.relatorios != null && this.perfil.relatorios.some(t => t === p.id)) {
          this.checklistSelectionRelatorios.select(p);
        }
      });

      this.carregandoService.esconde('buscarRelatorios');
    }, (erro) => {
      this.carregandoService.esconde('buscarRelatorios');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosPerfil() {
    this.buscarTelas();
    this.buscarRelatorios();
    this.carregando = false;

    this.carregandoService.esconde('buscaPerfil');
  }

  salvar() {
    this.carregandoService.mostra('salvaPerfil');

    this.perfil.telas = [];
    this.perfil.relatorios = [];

    this.checklistSelection.selected.forEach(p => {
      if (p.tipo === 1) {
        if (!this.perfil.telas.some(t => t === p.id)) {
          this.perfil.telas.push(p.id);
        }
        if (p.idPai !== null && !this.perfil.telas.some(t => t === p.idPai)) {
          this.perfil.telas.push(p.idPai);
        }
      }
    });

    this.checklistSelectionRelatorios.selected.forEach(p => {
      // if (p.tipo === 1) {
        if (!this.perfil.relatorios.some(t => t === p.id)) {
          this.perfil.relatorios.push(p.id);
        }
        if (p.idPai !== null && !this.perfil.relatorios.some(t => t === p.idPai)) {
          this.perfil.relatorios.push(p.idPai);
        }
      // }
    });

    this.perfilService.salvar(this.perfil).subscribe(() => {
      this.notificacaoService.sucesso('Permissão salva com sucesso!!!');
      this.router.navigate(['/configuracoes/permissoes-de-acesso']).then(() => {
        this.carregandoService.esconde('salvaPerfil');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaPerfil');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {
  }

  getLevel = (node: TodoItemFlatNode) => node.level;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: Tela): Tela[] => node.filhos;

  getChildrenRelatorios = (node: Relatorio): Relatorio[] => node.filhos;

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.descricao === '';

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformerTela = (node: Tela, level: number) => {
    const existingNode = this.nestedNodeMapTelas.get(node);
    const flatNode = existingNode && existingNode.id === node.id && existingNode.tipo === node.tipo
      ? existingNode
      : new TodoItemFlatNode();
    flatNode.id = node.id;
    flatNode.descricao = node.descricao;
    flatNode.tipo = node.tipo;
    flatNode.idPai = node.idPai;
    flatNode.level = level;
    flatNode.expandable = node.filhos && node.filhos.length > 0; //!!node.children?.length;
    this.flatNodeMapTela.set(flatNode, node);
    this.nestedNodeMapTelas.set(node, flatNode);
    return flatNode;
  }

  transformerRelatorio = (node: Relatorio, level: number) => {
    const existingNode = this.nestedNodeMapRelatorios.get(node);
    const flatNode = existingNode && existingNode.id === node.id && existingNode.tipo === node.tipo
      ? existingNode
      : new TodoItemFlatNode();
    flatNode.id = node.id;
    flatNode.descricao = node.descricao;
    flatNode.tipo = node.tipo;
    flatNode.idPai = node.idPai;
    flatNode.level = level;
    flatNode.expandable = node.filhos && node.filhos.length > 0;
    this.flatNodeMapRelatorios.set(flatNode, node);
    this.nestedNodeMapRelatorios.set(node, flatNode);
    return flatNode;
  }

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
    return descAllSelected;
  }

  descendantsAllSelectedRelatorios(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControlRelatorio.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelectionRelatorios.isSelected(child);
    });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  descendantsPartiallySelectedRelatorios(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControlRelatorio.getDescendants(node);
    const result = descendants.some(child => this.checklistSelectionRelatorios.isSelected(child));
    return result && !this.descendantsAllSelectedRelatorios(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  todoItemSelectionToggleRelatorios(node: TodoItemFlatNode): void {
    this.checklistSelectionRelatorios.toggle(node);
    const descendants = this.treeControlRelatorio.getDescendants(node);
    this.checklistSelectionRelatorios.isSelected(node)
      ? this.checklistSelectionRelatorios.select(...descendants)
      : this.checklistSelectionRelatorios.deselect(...descendants);

    // Force update for the parent
    descendants.forEach(child => this.checklistSelectionRelatorios.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  todoLeafItemSelectionToggleRelatorios(node: TodoItemFlatNode): void {
    this.checklistSelectionRelatorios.toggle(node);
    this.checkAllParentsSelectionRelatorios(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  checkAllParentsSelectionRelatorios(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelectionRelatorios(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelection.isSelected(child);
    });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  checkRootNodeSelectionRelatorios(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelectionRelatorios.isSelected(node);
    const descendants = this.treeControlRelatorio.getDescendants(node);
    const descAllSelected = descendants.length > 0 && descendants.every(child => {
      return this.checklistSelectionRelatorios.isSelected(child);
    });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelectionRelatorios.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelectionRelatorios.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  mostrarSelecionados() {}
}
